var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_41268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3216 10.6534C16.4644 10.9723 12.4896 14.8284 12.0446 19.6634C11.5997 24.491 14.5289 28.5696 18.7113 30.0231C19.1637 30.1788 19.5567 30.468 19.8385 30.8537L21.4996 33.1228C21.7443 33.464 22.256 33.464 22.5081 33.1228L24.1692 30.8537C24.451 30.468 24.8515 30.1788 25.3038 30.0231C29.2044 28.666 32.0076 24.9656 32.0076 20.6126C32.0001 14.8729 27.1503 10.2678 21.3216 10.6534ZM21.9668 28.0431C17.8511 28.0431 14.5215 24.6764 14.5215 20.5237C14.5215 16.3709 17.8511 13.0116 21.9594 13.0116C26.0676 13.0116 29.4047 16.3783 29.4047 20.5311C29.4047 24.6838 26.0676 28.0505 21.9594 28.0505L21.9668 28.0431Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.13 15.7246H20.9127C20.6976 15.7246 20.5271 15.91 20.5419 16.1251L20.9201 22.0427C20.9349 22.243 21.0981 22.3913 21.2909 22.3913H22.7592C22.9594 22.3913 23.1151 22.2355 23.13 22.0427L23.5082 16.1251C23.523 15.91 23.3524 15.7246 23.1374 15.7246H23.13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2923 23.4531H22.7606C22.9682 23.4531 23.1388 23.6237 23.1388 23.8313V25.307C23.1388 25.5147 22.9682 25.6852 22.7606 25.6852H21.2923C21.0846 25.6852 20.9141 25.5147 20.9141 25.307V23.8313C20.9141 23.6237 21.0846 23.4531 21.2923 23.4531Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_41268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22.7364,
    fill: "white",
    transform: "translate(12 10.6309)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteEvents);
export default __webpack_public_path__ + "static/media/Site_events.9262b19a392e2534d812da466f3fcc92.svg";
export { ForwardRef as ReactComponent };